import { IconProps } from './interfaces'

const SVG = ({ width = '31', height = '32', viewBox = '0 0 31 32' }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_37008_2058)">
      <path
        d="M22.846 21.2467H21.7965C21.2088 21.2467 20.7471 20.7745 20.7471 20.1973V14.9499C20.7471 14.3622 21.2088 13.9004 21.7965 13.9004H22.846C24.0005 13.9004 24.945 14.8344 24.945 15.9993V19.1478C24.945 20.3022 24.0005 21.2467 22.846 21.2467Z"
        stroke="#222B45"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.20349 21.2467H8.15401C6.99434 21.2467 6.05505 20.3022 6.05505 19.1478V15.9993C6.05505 14.8344 6.99434 13.9004 8.15401 13.9004H9.20349C9.7807 13.9004 10.253 14.3622 10.253 14.9499V20.1973C10.253 20.7745 9.7807 21.2467 9.20349 21.2467Z"
        stroke="#222B45"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3214 13.901V13.3763C22.3214 9.60867 19.2675 6.55469 15.4998 6.55469C11.7322 6.55469 8.67822 9.60867 8.67822 13.3763V13.901"
        stroke="#222B45"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1563 25.7077H14.8444C14.1203 25.7077 13.5326 25.12 13.5326 24.3958C13.5326 23.6717 14.1203 23.084 14.8444 23.084H16.1563C16.8804 23.084 17.4681 23.6717 17.4681 24.3958C17.4681 25.12 16.8804 25.7077 16.1563 25.7077Z"
        stroke="#222B45"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4622 24.3965H19.6871C20.8415 24.3965 21.786 23.452 21.786 22.2975V21.248"
        stroke="#222B45"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_37008_2058">
        <rect
          width="25.1875"
          height="25.1875"
          fill="white"
          transform="translate(2.90625 3.40625)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SVG
